import { IConfig } from './base/typings';

const env = __APP_ENV__;

const config: IConfig = {
    mode: env.APP_MODE,
    developmentMode: {
        disableStrictMode: env.DISABLE_STRICT_MODE,
    },
    hosts: {
        appHost: env.HOST_APP,
        apiHost: env.HOST_API,
        wsHost: env.HOST_WS,
        mcApiHost: env.HOST_MC_API,
        streamojiApiHost: env.HOST_STREAMOJI_API,
        ttsProxyApiHost: env.HOST_TTS_PROXY_API,
        leaderboardDemoAvatarsUrl: env.LEADERBOARD_DEMO_AVATARS_URL,
    },
    layout: {
        desktopLayoutMinWidth: env.LAYOUT_DESKTOP_MIN_WIDTH,
        responsivePage: {
            contentWidth: env.LAYOUT_RESPONSIVE_CONTENT_WIDTH,
            sidebarWidth: env.LAYOUT_RESPONSIVE_SIDEBAR_WIDTH,
        },
    },
    logging: {
        level: env.LOG_LEVEL,
    },
    obs: {
        minStickerPlayingTimeSec: 5,
        stickerSize: {
            xsmall: env.OBS_STICKER_SIZE_XSMALL,
            small: env.OBS_STICKER_SIZE_SMALL,
            medium: env.OBS_STICKER_SIZE_MEDIUM,
            large: env.OBS_STICKER_SIZE_LARGE,
        },
    },
    additional: {
        telegramBotName: env.TELEGRAM_BOT_NAME,
        telegramCommonBotName: env.TELEGRAM_COMMON_BOT_NAME,
    },
};

export default config;
